module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"log.company":"จากศูนย์","log.updated_datetime":"เมื่อ","log.not_valid":"ไม่มีข้อมูล","log.reason":"เนื่องจาก : {reason}","log.before_status":"สถานะก่อนหน้าคือ {status}"}}')
  delete Component.options._Ctor
}
